export default __webpack_public_path__ + "static/media/wavy.2652df16.jpg";